var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-alert',{staticClass:"m-t-2 m-b-2",attrs:{"show-icon":"","title":"","closable":false}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.content)}}),(_vm.debug.visible)?_c('DebugItem',{attrs:{"data":_vm.data}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }